import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const slug = "reporttype";

const ReportTypeServices = {
  // Define your API functions here

  getList: async ({ pageNumber, pageSize }) => {
    const response = await apiService.get(
      `/${slug}/getlist?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post(`/${slug}/create`, data);
    return response.data;
  },
  update: async ({ id, data }) => {
    const response = await apiService.patch(`/${slug}/update?id=${id}`, data);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/${slug}/getdetail?id=${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/delete?id=${id}`);
    return response.data;
  },
};

export default ReportTypeServices;
